"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(conf) {
  var _window, _window$LEXUS, _window$LEXUS$config, _process, _process$env;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$LEXUS = _window.LEXUS) === null || _window$LEXUS === void 0 ? void 0 : (_window$LEXUS$config = _window$LEXUS.config) === null || _window$LEXUS$config === void 0 ? void 0 : _window$LEXUS$config[conf]) || ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env[conf]);
};